import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="relative bg-carbon border-t border-pewter/60" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 md:py-24">
        {/* Top grid */}
        <div className="grid md:grid-cols-12 gap-10 md:gap-14 mb-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="Snatched Beauties Privé" className="h-12 w-12 object-contain" />
              <div>
                <p className="font-serif text-ivory text-xl">
                  Snatched Beauties <span className="brand-italic chrome-rose">Privé</span>
                </p>
                <p className="eyebrow mt-1">by {businessInfo.legalName}</p>
              </div>
            </div>
            <p className="font-serif brand-italic chrome-rose text-xl md:text-2xl leading-snug mb-6 max-w-md">
              "{businessInfo.tagline}"
            </p>
            <p className="text-silverx text-sm leading-relaxed max-w-md">
              {businessInfo.description}
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Navigate</p>
            <ul className="space-y-3 text-platinum text-sm">
              <li><a href="#home" className="hover:text-blush transition-colors">Home</a></li>
              <li><a href="#services" className="hover:text-blush transition-colors">Treatments</a></li>
              <li><a href="#about" className="hover:text-blush transition-colors">Studio</a></li>
              <li><a href="#results" className="hover:text-blush transition-colors">Results</a></li>
              <li><a href="#contact" className="hover:text-blush transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Visit */}
          <div className="md:col-span-4">
            <p className="eyebrow mb-5">Studio</p>
            <p className="text-ivory text-sm leading-relaxed mb-3">{businessInfo.address}</p>
            <p className="text-silverx text-sm leading-relaxed mb-1">{businessInfo.hours.weekday}</p>
            <p className="text-silverx text-sm leading-relaxed mb-6">{businessInfo.hours.weekend}</p>
            <a
              href={`tel:${businessInfo.phone}`}
              className="block text-ivory text-sm hover:text-blush transition-colors"
            >
              {businessInfo.phone}
            </a>
            <a
              href={`mailto:${businessInfo.email}`}
              className="block text-ivory text-sm hover:text-blush transition-colors mt-1"
            >
              {businessInfo.email}
            </a>
          </div>
        </div>

        <div className="hairline mb-8" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-5">
            <p className="text-silverx text-xs tracking-[0.18em] uppercase">
              © {year} {businessInfo.legalName}. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="/privacy"
                className="text-silverx hover:text-blush text-xs tracking-[0.18em] uppercase transition-colors"
                data-testid="footer-privacy-link"
              >
                Privacy
              </a>
              <span aria-hidden="true" className="text-pewter">·</span>
              <a
                href="/terms"
                className="text-silverx hover:text-blush text-xs tracking-[0.18em] uppercase transition-colors"
                data-testid="footer-terms-link"
              >
                Terms
              </a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {[
              { Icon: Instagram, url: businessInfo.social.instagram, label: 'Instagram' },
              { Icon: Facebook, url: businessInfo.social.facebook, label: 'Facebook' },
              { Icon: Youtube, url: businessInfo.social.youtube, label: 'YouTube' },
            ].map(({ Icon, url, label }) => (
              <a
                key={label}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-10 h-10 border border-pewter flex items-center justify-center text-platinum hover:text-onyx hover:bg-blush hover:border-blush transition-colors"
              >
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
